// extracted by mini-css-extract-plugin
export default {"container":"ThankYouPage_container__xtgy2","paper":"ThankYouPage_paper__FftAL","icon":"ThankYouPage_icon__B4aN6","text":"ThankYouPage_text__i2yxF"};